import { EMAIL_BUILDER_SETTINGS_SHEET_OVERLAY_PORTAL_ID } from "./canvas/settings/emailBuilderSettingsOverlayPortal";

export const EMAIL_BUILDER_BANNER_ROOT_SELECTOR = ".email-builder-banner";
export const EMAIL_BUILDER_CANVAS_HOST_SELECTOR = "#email-builder-main";

export function shouldIgnoreEmailBuilderToolbarDismissTarget(target: Node): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  if (target.closest(EMAIL_BUILDER_BANNER_ROOT_SELECTOR)) {
    return true;
  }

  const portalRoot = document.getElementById("portal-root");
  if (portalRoot?.contains(target)) {
    return true;
  }

  const settingsSheetPortal = document.getElementById(EMAIL_BUILDER_SETTINGS_SHEET_OVERLAY_PORTAL_ID);
  if (settingsSheetPortal?.contains(target)) {
    return true;
  }

  if (target.closest(".ui-bottom-sheet-dialog")) {
    return true;
  }

  if (target.closest(".modal")) {
    return true;
  }

  return false;
}
